import { withStyles } from '@material-ui/core';

import PageSubtitle from './component';
import styles from './styles';

export default withStyles(styles)(PageSubtitle);
